import React from 'react';
import PropTypes from 'prop-types';
import styles from './Fader.scss';
import SwitchTransition from 'react-transition-group/SwitchTransition';
import CSSTransition from 'react-transition-group/CSSTransition';
import classNames from 'classnames';
import _ from 'lodash';

class FaderContent extends React.Component {
  componentDidMount() {
    this.props.onResize();
  }

  componentWillUnmount() {
    cancelAnimationFrame(this.animationFrame);
  }

  onResize = () => {
    this.animationFrame = requestAnimationFrame(() => {
      this.props.onResize();
    });
  };

  render() {
    const { contentRef, children } = this.props;
    const isString = typeof children === 'string';

    const innerComponent = isString
      ? children
      : React.cloneElement(children, {
          onResize: this.onResize,
        });

    return (
      <div className={styles.contentWrapper} ref={contentRef}>
        {innerComponent}
      </div>
    );
  }
}

export default class Fader extends React.Component {
  contentRef = React.createRef();
  state = { height: null };
  isMounted = false;

  updateHeight = (node) => {
    this.animationFrame = requestAnimationFrame(() => {
      const height = (node || this.contentRef.current || {}).offsetHeight;
      if (this.isMounted && this.props.dynamicHeight && !_.isUndefined(height)) {
        this.setState({ height });
      }
    });
  };

  getTimeout() {
    const duration = parseInt(styles.duration, 10);
    const delay = parseInt(styles.delay, 10);

    const result = {
      exit: duration,
      enter: duration,
    };

    if (this.props.delayedEnter) {
      result.enter += delay;
    }

    return result;
  }

  componentDidMount() {
    this.isMounted = true;
  }

  componentWillUnmount() {
    this.isMounted = false;
    cancelAnimationFrame(this.animationFrame);
  }

  render() {
    const { primary, secondary, drilldown, delayedEnter } = this.props;
    const { height } = this.state;
    const component = drilldown ? secondary : primary;
    const wrapper = classNames([styles.wrapper, drilldown && styles.isDrilling, delayedEnter && styles.delayedEnter]);

    return (
      <div className={wrapper} style={{ height }}>
        <SwitchTransition>
          <CSSTransition
            classNames={styles}
            timeout={this.getTimeout()}
            key={drilldown}
            onEnter={this.updateHeight}
            onExit={this.updateHeight}
          >
            <FaderContent onResize={this.updateHeight} contentRef={this.contentRef}>
              {component}
            </FaderContent>
          </CSSTransition>
        </SwitchTransition>
      </div>
    );
  }
}

Fader.displayName = 'Fader';
Fader.propTypes = {
  dynamicHeight: PropTypes.bool,
  delayedEnter: PropTypes.bool,
  drilldown: PropTypes.bool,
  primary: PropTypes.node,
  secondary: PropTypes.node,
};
